import './bannerNotifications.less';

export function getCurrentSale() {
  const blackFridayObj = {
    className: 'black-friday',
    startDate: new Date('Nov 24, 2023 05:00:00 PST').getTime(),
    endDate: new Date('Nov 26, 2023 23:59:59 PST').getTime(),
    message: "It's the Black Friday Sale! Our best offer ever ends in ",
    mobileMessage: 'Black Friday Sale: 60% Off Premium',
  };

  const cyberMondayObj = {
    className: 'cyber-monday',
    startDate: new Date('Nov 27, 2023 00:00:00 PST').getTime(),
    endDate: new Date('Nov 27, 2023 23:59:59 PST').getTime(),
    message: 'Cyber Monday Sale: 60% off Premium! Our best offer ends in ',
    mobileMessage: 'Cyber Monday: 60% Off Premium',
  };

  const cyberWeekObj = {
    className: 'cyber-week',
    startDate: new Date('Nov 28, 2023 00:00:00 PST').getTime(),
    endDate: new Date('Dec 3, 2023 23:59:59 PST').getTime(),
    message: 'Cyber Week Sale: 60% off Premium! Our best offer ends in ',
    mobileMessage: 'Cyber Week Sale: 60% Off Premium',
  };

  const now = new Date().getTime();

  if (now >= blackFridayObj.startDate && now <= blackFridayObj.endDate) {
    return blackFridayObj;
  } else if (now >= cyberMondayObj.startDate && now <= cyberMondayObj.endDate) {
    return cyberMondayObj;
  } else if (now >= cyberWeekObj.startDate && now <= cyberWeekObj.endDate) {
    return cyberWeekObj;
  } else {
    return null;
  }
}

export function updateBFCMBanner() {
  // Countdown Clock Banner Code for Black Friday, Cyber Monday, and Cyber Week

  // Update the countdown every 1 second
  var x = setInterval(function() {
    // Get today's date and time
    var now = new Date().getTime();
    let saleObj = getCurrentSale();
    let countDownDate = saleObj.endDate;

    // Time calculations for days, hours, minutes and seconds
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24))
      .toString()
      .padStart(2, '0');
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
      .toString()
      .padStart(2, '0');
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      .toString()
      .padStart(2, '0');
    var seconds = Math.floor((distance % (1000 * 60)) / 1000)
      .toString()
      .padStart(2, '0');

    //Set text to be plural iff there are multiple of that type
    var dayText = days === '01' ? 'day' : 'days';
    var hourText = hours === '01' ? 'hour' : 'hours';
    var minuteText = minutes === '01' ? 'minute' : 'minutes';
    var secondText = seconds === '01' ? 'second' : 'seconds';

    if (document.getElementById('bfcm-banner')) {
      document.getElementById('bfcm-banner').classList.add(saleObj.className);
      document.getElementById('bfcm-banner').innerHTML =
        '<span class="flash-sale-msg bfcm-msg">' +
        '<span class="desktop">' +
        saleObj.message +
        '<span id="countdown-clock" class="countdown-clock">' +
        '<p id="days"><span class="box">' +
        days +
        '</span><small>' +
        dayText +
        '</small></p>' +
        '<p id="hours"><span class="box">' +
        hours +
        '</span><small>' +
        hourText +
        '</small></p>' +
        '<p id="minutes"><span class="box">' +
        minutes +
        '</span><small>' +
        minuteText +
        '</small></p>' +
        '<p id="seconds"><span class="box">' +
        seconds +
        '</span><small>' +
        secondText +
        '</small></p>' +
        '</span>' +
        '</span>' +
        '<span class="mobile">' +
        saleObj.mobileMessage +
        '</span>' +
        '<span class="btn btn-black-fri btn-round" style="margin-left: 10px;">Redeem now</span>' +
        '</span>';

      if (document.getElementById('bfcm-banner').classList.contains('hidden')) {
        document.getElementById('bfcm-banner').classList.remove('hidden');
      }
    }

    // If the countdown is finished, write some text
    if (countDownDate - now <= 0) {
      document.getElementById('bfcm-banner').style.display = 'none';
      clearInterval(x);
    }
  }, 1000);
}
